import { render } from "./startup-component.vue?vue&type=template&id=616c5330&ts=true"
import script from "./startup-component.vue?vue&type=script&lang=ts"
export * from "./startup-component.vue?vue&type=script&lang=ts"

import "./startup-component.vue?vue&type=style&index=0&id=616c5330&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__